import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
  skeleton: false,
  isDocumentUploading: false,
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.loader = true;
    },
    hideLoader: (state) => {
      state.loader = false;
    },
    showSkeleton: (state, action) => {
      state.skeleton = true;
    },
    hideSkeleton: (state) => {
      state.skeleton = false;
    },
    setDocumentUploading: (state, action) => {
      state.isDocumentUploading = action.payload;
    },
  },
});

export const {
  showLoader,
  hideLoader,
  showSkeleton,
  hideSkeleton,
  setDocumentUploading,
} = loaderSlice.actions;

export const isLoaderActive = (state) => state.loader?.loader;
export const isSkeletonActive = (state) => state.loader?.skeleton;
export const isDocumentUploading = (state) => state.loader?.isDocumentUploading;

export default loaderSlice.reducer;
